import React from "react";
import Meta from "./../components/Meta";
import HeroSection from "./../components/HeroSection";

export default function IndexPage() {
  return (
    <>
      <Meta />
      <HeroSection
        appStoreUrl="https://apps.apple.com/us/app/id6749470124"
        contactUrl="mailto:hello@jyni.app"
        privacyUrl="/privacy"
        termsUrl="/terms"
      />
    </>
  );
}
